import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoClaimRakurakuHistorysGetRes } from "./abst/DtoClaimRakurakuHistorysGetRes";

export class DtoClaimRakurakuHistorysGetResImple extends DtoClaimRakurakuHistorysGetRes {
  public pager = new DtoApiPager();
}
